import React, { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabase';
import { createCustomerSegment, enrollSegmentInNurtureSequence, CustomerSegment } from '@/lib/nurture-sequences';

const NurtureSequencesPage: React.FC = () => {
  const [segments, setSegments] = useState<CustomerSegment[]>([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchSegments();
  }, []);

  const fetchSegments = async () => {
    setError(null);
    const { data, error } = await supabase.from('customer_segments').select('*');
    if (error) {
      console.warn('Failed to fetch segments', error);
      setError(error.message);
    }
    setSegments(data || []);
    setLoading(false);
  };

  const handleCreateSegment = async () => {
    const newSegment = {
      name: 'New Segment',
      description: 'A new customer segment.',
      company_id: 'halesac',
      criteria: {},
    };
    setMessage(null);
    setError(null);
    try {
      const data = await createCustomerSegment(newSegment);
      setSegments(prev => [...prev, data]);
      setMessage('Segment created successfully.');
    } catch (e: any) {
      console.warn('createCustomerSegment failed; using dev fallback', e);
      const sample: CustomerSegment = {
        id: `local-${Date.now()}`,
        name: newSegment.name,
        description: newSegment.description!,
        company_id: newSegment.company_id,
        criteria: newSegment.criteria,
      } as any;
      setSegments(prev => [...prev, sample]);
      setMessage('Dev fallback: showing local segment (DB insert likely blocked by RLS).');
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Hyper-Personalized Customer Nurture Sequences</h1>
      
      <div className="mb-4">
        <button onClick={handleCreateSegment} className="bg-blue-500 text-white px-4 py-2 rounded">
          Create New Segment
        </button>
      </div>

      {message && <div className="mb-4 p-3 rounded bg-green-50 text-green-700">{message}</div>}
      {error && <div className="mb-4 p-3 rounded bg-red-50 text-red-700">{error}</div>}

      {loading ? (
        <p>Loading segments...</p>
      ) : (
        <div className="space-y-4">
          {segments.map(segment => (
            <div key={segment.id} className="p-4 border rounded">
              <p>{segment.name}</p>
              <p className="text-sm text-gray-500">{segment.description}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default NurtureSequencesPage;
